module.exports = __webpack_public_path__ + "img/pc_banner_sup_login.c702941d.webp";